<template>
  <SidebarModal :modal="modal">
    <div class="h-full bg-gray-100 dark:bg-neutral-800">
      <LoadingOverlay
        :active="loading"
        :overlay="false"
        size="md"
        class="h-full"
      >
        <template v-if="construction">
          <!-- <div v-if="construction" class="h-full bg-gray-100 dark:bg-neutral-800"> -->
          <div
            class="shadow-around absolute bottom-2 left-2 z-10 rounded-xl bg-white backdrop-blur-md dark:bg-neutral-900 lg:left-4"
            :class="{
              'sm:w-90 w-[calc(100%-4*var(--spacing))] p-4 dark:ring-1 dark:ring-neutral-800':
                showInfo,
              'p-1.5 sm:w-auto': !showInfo,
            }"
          >
            <template v-if="showInfo">
              <p
                v-if="currentAlbum"
                class="mb-1 text-sm text-gray-400 dark:text-neutral-500"
              >
                {{ currentAlbum.name }}
              </p>
              <p class="mb-2 text-xl">
                {{ construction.date }}
              </p>
              <p
                v-if="construction.description"
                class="text-sm text-gray-400 dark:text-neutral-500"
              >
                {{ construction.description }}
              </p>
              <p
                v-if="currentItem.description"
                class="text-sm text-gray-400 dark:text-neutral-500"
              >
                {{ currentItem.description }}
              </p>

              <div class="mt-3 flex gap-1">
                <button
                  v-if="meta.prev"
                  class="btn h-9 w-full justify-center"
                  :class="{
                    'btn-primary': isLastSlide,
                    'bg-gray-100 text-gray-700 hover:bg-gray-200 dark:bg-neutral-800 dark:text-neutral-300 dark:dark:hover:bg-neutral-700':
                      !isLastSlide,
                  }"
                  @click.prevent="previousAlbum()"
                >
                  {{ $t('control.Previous report') }}
                </button>
                <button
                  class="btn h-9 bg-gray-100 bg-gray-100 px-4 text-gray-700 hover:bg-gray-200 dark:bg-neutral-800 dark:text-neutral-300 dark:dark:hover:bg-neutral-700"
                  :class="{
                    'w-full justify-center': !meta.prev,
                  }"
                  @click.prevent="showInfo = false"
                >
                  <LucideIcon icon="EyeOff" :size="14" class="me-1" />

                  {{ $t('control.Hide') }}
                </button>
              </div>
            </template>
            <button
              v-else
              class="btn h-9 bg-gray-100 px-4 text-gray-600 hover:bg-gray-200 dark:bg-neutral-800 dark:text-neutral-500 dark:hover:bg-neutral-700"
              :class="{
                'px-4': !$windowSize.isMobile,
                'w-9 justify-center !px-0': $windowSize.isMobile,
              }"
              @click.prevent="showInfo = true"
            >
              <LucideIcon icon="Eye" :size="14" class="md:me-1" />
              <template v-if="!$windowSize.isMobile">
                {{ $t('control.Show description') }}
              </template>
            </button>
          </div>

          <VueSlickCarousel
            ref="fullSlick"
            class="construction-slider-slick group/slick h-full"
            v-bind="modalSlickConstructionSettings"
            @beforeChange="syncConstructionSlider"
          >
            <template v-for="(item, index) in items">
              <div
                :key="item.id"
                class="group/slide pointer-events-all relative"
              >
                <ImageZoom
                  :src="item.media"
                  :active="currentSlideIndex == index"
                  class="bg-gray-100 dark:bg-neutral-900/90"
                ></ImageZoom>
              </div>
            </template>

            <template #prevArrow>
              <button
                class="z-3 size-10 md:group-hover/slick:not-[.slick-disabled]:shadow-around md:group-hover/slick:not-[.slick-disabled]:backdrop-blur-xs md:group-hover/slick:not-[.slick-disabled]:bg-white/70 dark:md:group-hover/slick:not-[.slick-disabled]:bg-neutral-900/90 not-[.slick-disabled]:cursor-pointer max-md:shadow-around max-md:backdrop-blur-xs md:group-hover/slick:not-[.slick-disabled]:opacity-100 dark:not-[.slick-disabled]:text-neutral-300 hover:!bg-primary hover:!text-onPrimary [.slick-disabled]:opacity-30 [.slick-disabled]:pointer-events-none absolute left-2 top-[calc(50%-5*var(--spacing))] flex items-center justify-center rounded-lg text-neutral-800 transition-[color,background-color,opacity] max-md:bg-white/70 max-md:opacity-100 dark:max-md:bg-neutral-900/90 md:opacity-60"
              >
                <lucide-icon icon="ChevronLeft" :size="22" />
              </button>
            </template>
            <template #nextArrow>
              <button
                class="z-3 size-10 md:group-hover/slick:not-[.slick-disabled]:shadow-around md:group-hover/slick:not-[.slick-disabled]:backdrop-blur-xs md:group-hover/slick:not-[.slick-disabled]:bg-white/70 dark:md:group-hover/slick:not-[.slick-disabled]:bg-neutral-900/90 not-[.slick-disabled]:cursor-pointer max-md:shadow-around max-md:backdrop-blur-xs md:group-hover/slick:not-[.slick-disabled]:opacity-100 dark:not-[.slick-disabled]:text-neutral-300 hover:!bg-primary hover:!text-onPrimary [.slick-disabled]:opacity-30 [.slick-disabled]:pointer-events-none absolute right-2 top-[calc(50%-5*var(--spacing))] flex items-center justify-center rounded-lg text-neutral-800 transition-[color,background-color,opacity] max-md:bg-white/70 max-md:opacity-100 dark:max-md:bg-neutral-900/90 md:opacity-60"
              >
                <lucide-icon icon="ChevronRight" :size="22" />
              </button>
            </template>
          </VueSlickCarousel>
        </template>
      </LoadingOverlay>
    </div>
  </SidebarModal>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
// import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
// import "vue-slick-carousel/dist/vue-slick-carousel.css";
import { mapGetters, mapActions } from 'vuex';
import ImageZoom from '@/components/ui/ImageZoom';
import LoadingOverlay from '@/components/ui/LoadingOverlay';

import SidebarModal from '@/components/sidebar/SidebarModal.vue';

export default {
  name: 'ConstructionStageModal',
  components: {
    VueSlickCarousel,
    SidebarModal,
    ImageZoom,
    LoadingOverlay,
  },
  props: {
    modal: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      meta: null,
      construction: null,
      showInfo: true,
      loading: false,
      currentSlideIndex: 0,
      modalSlickConstructionSettings: {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        draggable: false,
        swipeToSlide: true,
        touchMove: false,
        swipe: false,
        rtl: this.$store.getters.isRtlLang ? true : false,
      },
    };
  },
  computed: {
    ...mapGetters(['estates']),

    items() {
      if (!this.construction?.items) {
        return [];
      }
      return this.construction.items;
    },
    isLastSlide() {
      return this.currentSlideIndex === this.items.length - 1;
    },
    currentItem() {
      return this.items[this.currentSlideIndex];
    },
    currentAlbum() {
      if (!this.construction?.albums || !this.currentItem) return null;
      return this.construction.albums.find(
        (album) => album.id === this.currentItem.album_id
      );
    },
  },
  watch: {
    'modal.payload.id': {
      handler: function (id) {
        if (id) {
          this.getAlbum(id);
        }
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions(['axiosWrapped', 'OPEN_SIDEBAR_MODAL']),

    async getAlbum(id) {
      this.loading = true;
      this.currentSlideIndex = 0;
      this.construction = null;
      this.meta = null;
      try {
        let response = await this.axiosWrapped({
          url: `public/construction-progress/${id}`,
        });
        response.data.data.date = this.formatDate(response.data.data.date);
        this.construction = response.data.data;
        this.meta = response.data.meta;
        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    previousAlbum() {
      // if (!this.meta.prev) {
      //   return;
      // }
      this.OPEN_SIDEBAR_MODAL({
        type: 'image-construction',
        sidebar_id: this.modal.sidebar_id,
        payload: {
          id: this.meta.prev,
        },
      });
    },

    syncConstructionSlider(currentPosition, nextPosition) {
      this.currentSlideIndex = nextPosition;
    },

    initModal() {
      // this.$nextTick(() => {
      //   this.$refs.fullSlick.goTo(this.currentSlideIndex);
      // });
    },

    formatDate(inputDate) {
      const date = new Date(inputDate);
      let options = { year: 'numeric', month: 'long', day: 'numeric' };
      const formattedDate = date.toLocaleDateString(this.locale, options);
      return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
    },
  },
};
</script>

<style lang="scss">
@reference "tailwindcss";
.construction-slider-slick.slick-slider {
  & .slick-list {
    @apply h-full;

    & .slick-track {
      @apply flex h-full;

      & .slick-slide {
        @apply w-full;

        & > div {
          @apply flex h-full;
        }
      }
    }
  }
}
</style>
